import { useEffect, useState } from "react";
import { api, money } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const statusStyle = {
  paid: "bg-[#1a1a1a] text-white",
  completed: "bg-[#1a1a1a] text-white",
  pending: "bg-[#f5f5f0] text-[#666]",
  initiated: "bg-[#f5f5f0] text-[#666]",
};

export default function Account() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="account-page" className="max-w-5xl mx-auto px-6 md:px-10 py-16">
      <div className="text-sm uppercase tracking-luxe text-[#999] mb-3">My Account</div>
      <h1 className="font-serif text-5xl tracking-tight mb-2">Hello, {user?.name.split(" ")[0]}</h1>
      <p className="text-[#666] mb-12">{user?.email}</p>

      <h2 className="font-serif text-3xl mb-6">Order History</h2>
      {loading ? (
        <div className="text-[#999] tracking-luxe uppercase text-sm">Loading…</div>
      ) : orders.length === 0 ? (
        <p data-testid="no-orders" className="text-[#666]">You have no orders yet.</p>
      ) : (
        <div className="space-y-5">
          {orders.map((o) => (
            <div key={o.id} data-testid={`order-${o.id}`} className="border border-[#e5e5e5] p-6">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <div className="text-sm text-[#999]">{new Date(o.created_at).toLocaleDateString()}</div>
                  <div className="font-medium">{money(o.amount)}</div>
                </div>
                <span
                  className={`text-[11px] uppercase tracking-luxe px-3 py-1 ${statusStyle[o.payment_status] || "bg-[#f5f5f0]"}`}
                >
                  {o.payment_status}
                </span>
              </div>
              <div className="flex flex-wrap gap-3">
                {o.items.map((it, idx) => (
                  <div key={idx} className="flex items-center gap-3 text-sm">
                    <div className="w-12 h-12 bg-[#f5f5f0] overflow-hidden">
                      <img src={it.image} alt={it.name} className="w-full h-full object-cover" />
                    </div>
                    <span>
                      {it.name} × {it.quantity}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
